import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { signOut, sendEmailVerification } from "firebase/auth";
import { auth } from "../firebase";

export default function AuthBar({ user }) {
  const navigate = useNavigate();
  const [verificationSent, setVerificationSent] = useState(false);

  const handleSendVerification = () => {
    if (auth.currentUser) {
      sendEmailVerification(auth.currentUser)
        .then(() => {
          setVerificationSent(true);
        })
        .catch(console.error);
    }
  };

  return (
    <div className="flex items-center gap-4 ">
      {user ? (
        <>
          <span className="text-sm">
            {user.displayName || user.email}
            {!user.emailVerified && (
              <span className="text-yellow-600 ml-2">(Not Verified)</span>
            )}
          </span>

          {!user.emailVerified && (
            <button
              className="px-3 py-1 rounded bg-yellow-500 text-white text-sm"
              onClick={handleSendVerification}
              disabled={verificationSent}
            >
              {verificationSent ? "Verification Sent" : "Verify Email"}
            </button>
          )}

          <button
            className="px-3 py-1 rounded bg-red-500 text-white text-sm"
            onClick={() => {
              signOut(auth).catch(console.error);
            }}
          >
            Sign out
          </button>
        </>
      ) : (
        <button
          className="px-3 py-1 rounded bg-blue-600 text-white text-sm"
          onClick={() => navigate("/signin")}
        >
          Sign in
        </button>
      )}
    </div>
  );
}
